import React from 'react';
import './style/Input.scss';

export default ({
    classList = '',
    placeholder,
    disabled,
    autocomplete,
    maxLength,
    nameInput,
    idInput,
    autofocus,
    value,
    readonly,
    charSize,
    onTouchStart,
    onClick,
    onKeyDown,
    onChange = () => {},
    showErrorBorder = false,
    ...rest
}) => {

    const handleChange = (event) => {
        onChange(event, event.target.value);
    };

    return (
        <input
            type='text'
            disabled={disabled}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            autoComplete={autocomplete}
            autoFocus={autofocus}
            onChange={handleChange}
            onClick={onClick}
            onTouchStart={onTouchStart}
            maxLength={maxLength}
            id={idInput}
            name={nameInput}
            className={`input_${classList}_${showErrorBorder ? 'rs-feedback-error' : ''}`}
            data-testid='input'
            value={value}
            readOnly={readonly}
            size={charSize}
            {...rest}
        />
    );
};